
import { Component, Vue, Prop } from 'vue-property-decorator';

export interface descModelProps {
  isFixed?: Boolean;
  width?: number;
  height?: number;
  maxHeight?: number;
  minHeight?: number;
  maxWidth?: number;
  minWidth?: number;
}

@Component({})
export default class extends Vue {
  @Prop({ default: '.png,.jpg' }) type!: string;
  @Prop({ default: '10' }) size!: string;
  @Prop({ default: true }) invaildH!: boolean;
  @Prop({ default: {} }) descModel!: descModelProps;
  @Prop({ default: 'img' }) imgclass!: any;
  @Prop({ default: '' }) imgStyle!: string;
  @Prop({ default: '' }) tipStyle!: string;
  @Prop() model!: any;
  imgTip: string = '';
  beforeImgUpLoad(file: any) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onload = (e: any) => {
        let data = e.target.result;
        //加载图片获取图片真实宽度和高度
        let image = new Image();
        image.onload = async () => {
          let width = image.width;
          let height = image.height;
          file.image_height = height;
          file.image_width = width;
          let isPass = await this.uploadRules(file);
          if (!isPass) {
            reject();
          } else {
            resolve();
          }
        };
        image.src = data;
      };
      reader.readAsDataURL(file);
    }).then(
      () => {
        return file;
      },
      () => {
        return Promise.reject();
      }
    );
  }

  uploadRules(file: any) {
    return new Promise(resolve => {
      const isLt2M = file.size / 1024 / 1024 < Number(this.size);
      const isJPG = file.name.substring(file.name.lastIndexOf('.'), file.name.length);
      let istype = this.type.includes(`${isJPG}`);
      if (!istype) {
        this.$message.error(`图片格式仅支持 ${this.type} 格式，请重新上传`);
        resolve(false);
      }

      if (this.invaildH) {
        if (this.descModel.isFixed) {
          if (this.descModel.height) {
            if (file.image_height !== Number(this.descModel.height)) {
              this.$message.error('图片尺寸不符合要求，请重新上传!');
              resolve(false);
            }
          }
          if (this.descModel.width) {
            if (file.image_width !== Number(this.descModel.width)) {
              this.$message.error('图片尺寸不符合要求，请重新上传!');
              resolve(false);
            }
          }
          if (this.descModel.minWidth) {
            if (file.image_width < Number(this.descModel.minWidth)) {
              this.$message.error('图片尺寸不符合要求，请重新上传!');
              resolve(false);
            }
          }
          if (this.descModel.maxWidth) {
            if (file.image_width > Number(this.descModel.maxWidth)) {
              this.$message.error('图片尺寸不符合要求，请重新上传!');
              resolve(false);
            }
          }
          if (this.descModel.minHeight) {
            if (file.image_height < Number(this.descModel.minHeight)) {
              this.$message.error('图片尺寸不符合要求，请重新上传!');
              resolve(false);
            }
          }
          if (this.descModel.maxHeight) {
            if (file.image_height > Number(this.descModel.maxHeight)) {
              this.$message.error('图片尺寸不符合要求，请重新上传!');
              resolve(false);
            }
          }
        }

        if (file.image_height > Number(this.descModel.height) || file.image_width > Number(this.descModel.width)) {
          {
            this.$message.error('图片尺寸不符合要求，请重新上传!');
            resolve(false);
          }
        }
      }
      if (!isLt2M) {
        this.$message.error(`图片大小不能超过${this.size}MB`);
        resolve(false);
      }
      resolve(true);
    });
  }
  uploadSuccess(file: any) {
    let files = file.status;
    this.model.imageUrl = files.preview_url;
    this.model.width = files.image_width;
    this.model.height = files.image_height;
  }

  mounted() {
    if (this.descModel.isFixed) {
      this.imgTip = '';
    } else {
      this.imgTip = '小于';
    }
  }
}
